module.exports = "/ui/9a3e00de7ae251076b1d7747d3548779.png";